<template>
    <div class="" style="max-width: 100%;">
        <v-card class="gradient-primary" flat>
            <v-card-title class="pa-3">
                <div class="header-content">
                    <div class="header-left">
                        <v-avatar size="32" color="white" class="mr-4">
                            <v-icon color="dark" size="24">mdi-checkbox-multiple-outline</v-icon>
                        </v-avatar>
                        <div style="flex: 1 1 0%;">
                            <h1 class="text-h4 font-weight-bold white--text mb-1">
                                Parámetros de Materiales
                            </h1>
                        </div>
                    </div>
                    <v-text-field v-model="filter.Search" placeholder="Buscar transportistas..."
                        prepend-inner-icon="mdi-magnify" outlined dense hide-details class="search-field-header"
                        clearable dark color="white" @click:clear="filter.Search = ''">
                    </v-text-field>
                </div>
            </v-card-title>
        </v-card>

        <s-crud title="" :filter="filter" noSearch height="400" :config="config" add @save="save()"
            @addEvent="() => { }" :edit="selected.length > 0" @EditEvent="() => { }" @rowSelected="rowSelected($event)"
            remove @dblClick="dblclick($event)" ref="crudptm">

            <template scope="props">
                <v-card class="elevation-10">
                    <v-card-text class="pt-4" style="">
                        <v-form ref="formmaterials">
                            <v-row dense>
                                <v-col cols="12" sm="3" md="3" lg="4">
                                    <s-select-definition :def="1607" label="Tipo de Material" noDefault
                                        v-model="form.TypeMaterial" clearable></s-select-definition>
                                </v-col>
                                <v-col cols="12" sm="6" md="3" lg="2">
                                    <s-text label="Parámetro Equivalente" suffix="Kg" v-model="form.Parameter"
                                        type="number" ref="Parameter"></s-text>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="2">
                                    <s-text label="Cantidad" v-model="form.Quantity" ref="Quantity"
                                        type="number"></s-text>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </template>

        </s-crud>
    </div>
</template>

<script>
import _ParamsTypeMaterialService from "@/services/Technicalassistance/ParamsTypeMaterialService.js";

export default {
    components: {},
    data: () => ({
        form: {
            PtmID: 0,
            TypeMaterial: 0,
            Parameter: 0,
            Quantity: 1,
            SecStatus: 1,
        },
        filter: {
            Search: '',
        },
        selected: [],
        config: {
            model: {
                PtmID: "ID",
                TypeMaterial: "int",
                TypeMaterialName: "string",
                Quantity: "numeric",
                Parameter: "numeric",
            },
            service: _ParamsTypeMaterialService,
            headers: [
                { text: "ID", value: "PtmID", width: 40, align: "center" },
                { text: "MATERIAL", value: "TypeMaterialName", align: "left" },
                { text: "PARÁMETRO", value: "Parameter", width: 40, align: "center" },
                { text: "CANTIDAD", value: "Quantity", align: "center" },
            ],
        },
    }),
    methods: {
        save() {
            let TypeMaterial = this.form.TypeMaterial ?? 0;
            if (!parseInt(TypeMaterial || 0) > 0) {
                this.$fun.alert("Seleccionar tipo de material", "warning");
                return;
            }
            let Quantity = this.form.Quantity ?? 0;
            if (!parseInt(Quantity || 0) > 0) {
                this.$fun.alert("Seleccionar cantidad", "warning");
                return;
            }
            let Param = this.form.Parameter ?? 0;
            if (!parseInt(Param || 0) > 0) {
                this.$fun.alert("Ingresar parámetro", "warning");
                return;
            }

            const UsrCreateID = this.$fun.getUserID();
            this.form.UsrCreateID = UsrCreateID;
            const mensaje = this.form.PtmID == 0 ? "¿Seguro de Guardar?" : "¿Seguro de Actualizar?";

            this.$fun.alert(mensaje, "question").then((val) => {
                if (val.value) {
                    _ParamsTypeMaterialService.save(this.form, UsrCreateID).then((result) => {
                        // console.log(result)
                        if (result.status == 200) {
                            const msgAlert = this.form.PtmID > 0 ? "Datos actualizados correctamente" : "Datos guardados correctamente";
                            this.$fun.alert(msgAlert, "success");
                            this.$refs.crudptm.refresh();
                            this.resetForm()
                        }
                    }).catch((error) => {
                        if (error.response) {
                            this.$fun.alert(error.response.data.Message, "error");
                        } else if (error.request) {
                            console.error('No hubo respuesta del servidor');
                            this.$fun.alert("No hubo respuesta del servidor", "error");
                        } else {
                            console.error('Error al configurar la solicitud:', error.message);
                            this.$fun.alert("Error al guardar los datos: " + error.message, "error");
                        }
                    });
                }
            })
        },
        rowSelected(item) {
            this.selected = [{ ...item[0] }]
        },
        dblclick(item) {
            this.form = { ...item };
            console.log(item)
            this.selected = [{ ...item }]
        },
        resetForm() {
            this.form = {
                PtmID: 0,
                TypeMaterial: 0,
                Parameter: 0,
                Quantity: 1,
                SecStatus: 1,
            };
        }
    },

    mounted() {

    }
};
</script>

<style scoped>
.gradient-primary {
    background: linear-gradient(135deg, #a4a4a4 29%, #322d38 100%);
}

.header-content {
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.header-left {
    width: 100%;
    display: flex;
    gap: 8px;
    align-items: center;
    flex: 1 1 0%;
}

.header-right {
    display: flex;
    justify-items: center;
    align-items: center !important;
    min-width: 300px;
}

.search-field-header {
    padding: 8px;
    align-items: center !important;
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: 1rem;
    max-width: 250px;
}

.search-field-header>>>.v-input__slot {
    background-color: rgba(255, 255, 255, 0.15) !important;
}

@media (max-width:768px) {
    .header-content {
        flex-direction: column;
    }

    .search-field-header {
        width: 100%;
        max-width: 80%;
    }
}
</style>